import styled from 'styled-components';
import btn_search from './btn_search.svg';

export const BtnSearch = ({ onClick }: { onClick: (e: React.MouseEvent<HTMLButtonElement>) => void }) => {
  return (
    <Btn onClick={onClick}>
      <BtnImg src={btn_search} />
    </Btn>
  );
};

const Btn = styled.button``;

const BtnImg = styled.img``;
